export default gatherImports;

function gatherImports(imports) {
	var chains = {};
	var identifierReplacements = {};

	imports.forEach(function (x) {
		x.specifiers.forEach(function (s) {
			if (s.isBatch) {
				return;
			}

			var name = s.as;
			var replacement = x.name + (s.isDefault ? "['default']" : "." + s.name);

			if (!x.passthrough) {
				identifierReplacements[name] = replacement;
			}

			chains[name] = replacement;
		});
	});

	return [chains, identifierReplacements];
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/builders/strictMode/utils/gatherImports.js.01-babel.map